import { Button } from "@material-ui/core";
import { maybe } from "@saleor/misc";
import { Editor } from "@tinymce/tinymce-react";
import React, { Dispatch, SetStateAction, useRef } from "react";
export interface MultimediaEditorProps {
  initialValue: string;
  setDirty: Dispatch<SetStateAction<boolean>>;
  update: (newtemplate: string) => void;
  dirty: boolean;
  editorHeight?: number;
  editorName: string;
}

const MultimediaEditor: React.FC<MultimediaEditorProps> = ({
  initialValue,
  setDirty,
  update,
  dirty,
  editorHeight,
  editorName
}) => {
  // useEffect(() => setDirty(false), [initialValue]);
  const editorRef = useRef(null);
  const height = maybe(() => editorHeight, 800);

  return (
    <>
      <Button disabled color={"primary"}>
        {editorName}
      </Button>
      <Editor
        tinymceScriptSrc="https://media.tijn.co/tinymce/js/tinymce/tinymce.min.js"
        onInit={(_, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        onDirty={() => setDirty(true)}
        onFocusOut={() => {
          if (dirty) {
            update(editorRef.current.getContent());
          }
        }}
        init={{
          height,
          menubar: true,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount"
          ],
          valid_elements: "* [*]",
          toolbar:
            "undo redo | fontsizeselect | " +
            "bold italic  forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist | " +
            "removeformat image link |  preview code",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          extended_valid_elements: "*[*]",
          valid_children: "+a[div]",
          protect: [/\{\{(#if|\/if|else|#each|\/each).*?\}\}/g]
        }}
      />
    </>
  );
};
export default MultimediaEditor;
